export enum LocationStatusFilter {
  ALL,
  ENABLED,
  DISABLED,
  ARCHIVED
}

export function LocationStatusFilterToString(type: LocationStatusFilter): string {
  switch (type) {
    case 0:
      return 'All';
    case 1:
      return 'Enabled';
    case 2:
      return 'Disabled';
    case 3:
      return 'Archived';
    default:
      return 'All';
  }
}
export type FilterType = { Id: number, Name: string }

export function LocationStatusFilterListInit(): Array<FilterType> {
  return [
    { Id: 0, Name: LocationStatusFilterToString(LocationStatusFilter.ALL) },
    { Id: 1, Name: LocationStatusFilterToString(LocationStatusFilter.ENABLED) },
    { Id: 2, Name: LocationStatusFilterToString(LocationStatusFilter.DISABLED) },
    { Id: 3, Name: LocationStatusFilterToString(LocationStatusFilter.ARCHIVED) },
  ];
}